import { BlueBirdTheme } from "@kitbird/core";
import React, { InputHTMLAttributes } from "react";
import styled from "styled-components";
import searchIcon from "../../assets/icons/search.svg";

const Search = styled.input`
  height: 40px;
  padding-left: 40px;
  background: url(${searchIcon}) no-repeat left;
  background-size: 16px;
  background-position: 16px;
  background-color: ${BlueBirdTheme.colors.primary[100]};

  border-radius: .5rem;
  border-color: unset;
  border-style: none;
`;

const SearchInput = (props: InputHTMLAttributes<HTMLInputElement>) => (
  <Search type="search" placeholder="Cari data" {...props} />
);

export default SearchInput;
